<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理组:</span>
            <Select
              v-model="table.params.plat_id"
              placeholder="下拉筛选盘口所属分组服务器"
              filterable
              clearable
              @on-change="GetAllAppList"
            >
              <Option
                v-for="(item, index) in select.platform_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理:</span>
            <Select
              v-model="table.params.app_id"
              placeholder="输入盘口名称、APPID或下拉筛选盘口"
              filterable
              clearable
              @on-change="GetAllAppProxyMch"
            >
              <Option
                v-for="(item, index) in select.appid_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">代付平台:</span>
            <Select
              v-model="table.params.pay_platform_id"
              placeholder="输入代付平台名称、代付平台ID或下拉筛选代付平台"
              filterable
              clearable
            >
              <Option
                v-for="(item, index) in select.pay_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="12" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="GetAppProxyMchConfigList()"
            >查询</Button
          >
          <div>
            <Button
              type="primary"
              @click.native="showChannelModal({ type: 1, params: {} })"
              style="margin-left: 10px"
              >新增代付平台</Button
            >
          </div>
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <Modal v-model="Channel_Modal.show" width="700">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span
          >{{
            Channel_Modal.type == 1
              ? "新增"
              : Channel_Modal.type == 3
              ? "复制"
              : Channel_Modal.type == 2
              ? "编辑"
              : "查看"
          }}盘口代付平台</span
        >
      </p>
      <div style="text-align: center">
        <Form
          :labelWidth="280"
          :rules="Channel_Modal.rules"
          :ref="Channel_Modal.ref"
          :model="Channel_Modal.data"
          :style="{ 'pointer-events': Channel_Modal.type == 4 ? 'none' : '' }"
        >
          <FormItem label="配置盘口" prop="app_id" style="text-align: left">
            <Select
              v-model="Channel_Modal.data.app_id"
              placeholder="筛选配置盘口"
              :disabled="Channel_Modal.type == 2"
              style="width: 270px"
              filterable
              clearable
            >
              <Option
                v-for="(item, index) in select.all_app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </FormItem>
          <FormItem
            label="代付平台:"
            prop="pay_platform_id"
            style="text-align: left"
            v-show="Channel_Modal.type != 3"
          >
            <Select
              v-model="Channel_Modal.data.pay_platform_id"
              filterable
              clearable
              placeholder="请配置代付平台名称"
              style="width: 270px"
              :disabled="Channel_Modal.type == 2"
            >
              <Option
                v-for="(item, index) in select.pay_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </FormItem>
          <FormItem label="商户ID(mch_id):" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_id"
              placeholder="请配置代付通道的商户ID"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem label="商户账号(mch_account)" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_account"
              placeholder="请配置代付通道的商户账号"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem label="商户密码(mch_key)" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_key"
              placeholder="请配置代付通道的商户密码"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem label="商户MD5密码(mch_md5_key)" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_md5_key"
              placeholder="请配置代付通道的商户MD5密码"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem label="Rsa公钥(mch_rsa_public)" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_rsa_public"
              placeholder="代付通道的Rsa公钥,如没有则置空"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem label="Rsa秘钥(mch_rsa_private)" style="text-align: left">
            <Input
              v-model="Channel_Modal.data.mch_rsa_private"
              placeholder="代付通道的Rsa秘钥,如没有则置空"
              style="width: 270px"
            ></Input>
          </FormItem>
          <FormItem
            label="平台备注信息:"
            style="text-align: left"
            v-show="!!rechage_channel.remark"
          >
            <div
              style="
                width: 260px;
                max-height: 100px;
                overflow: auto;
                border: 1px solid #dcdee2;
                border-radius: 4px;
                padding: 4px;
                line-height: 20px;
                min-height: 32px;
              "
            >
              {{ rechage_channel.remark }}
            </div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" v-show="Channel_Modal.type != 4">
        <Button type="warning" @click.native="closeChannelModal()">取消</Button>
        <Button type="success" @click.native="updateAppMchConfig()"
          >确认修改</Button
        >
      </div>
    </Modal>
    <Modal v-model="rechage_channel.show" width="900">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>盘口代付通道管理</span>
      </p>
      <div>
        <div style="text-align: right; margin-bottom: 5px">
          <Button
            type="primary"
            @click.native="showRechargeChannelModal({ id: 0, status: 1 })"
            >新增</Button
          >
        </div>
        <Table
          :columns="rechage_channel.columns"
          :data="rechage_channel.data"
          border
          :height="600"
        ></Table>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="rechage_channel.modalShow" width="500">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span
          >{{ rechage_channel.modalData["id"] ? "编辑" : "新增" }}代付通道</span
        >
      </p>
      <div style="text-align: center">
        <Form
          :labelWidth="150"
          :rules="rechage_channel.rules"
          :ref="rechage_channel.ref"
          :model="rechage_channel.modalData"
        >
          <Form-item label="通道状态:" tyle="text-align:left">
            <RadioGroup
              v-model="rechage_channel.modalData.status"
              style="display: flex"
            >
              <Radio :label="1">启用</Radio>
              <Radio :label="2">禁用</Radio>
            </RadioGroup>
          </Form-item>
          <FormItem label="代付通道名称:" prop="name" style="text-align: left">
            <Input
              v-model="rechage_channel.modalData.name"
              placeholder="代付通道名称"
              style="width: 250px"
            ></Input>
          </FormItem>
          <FormItem
            label="通道类型:"
            prop="channel_type"
            style="text-align: left"
          >
            <Select
              v-model="rechage_channel.modalData.channel_type"
              style="width: 250px"
            >
              <Option
                v-for="(item, index) in select.channel_type_list"
                :value="item.value"
                :key="index"
                placeholder="请选择通道类型"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="通道码:"
            prop="channel_code"
            style="text-align: left"
          >
            <Input
              v-model="rechage_channel.modalData.channel_code"
              placeholder="代付通道通道码"
              style="width: 250px"
            ></Input>
          </FormItem>
          <FormItem label="通道附加参数:" style="text-align: left">
            <Input
              v-model="rechage_channel.modalData.channel_attach_parm"
              placeholder="代付通道附加参数"
              style="width: 250px"
            ></Input>
          </FormItem>
          <FormItem label="通道URL:" style="text-align: left">
            <Input
              v-model="rechage_channel.modalData.channel_url"
              placeholder="代付通道URL"
              style="width: 250px"
            ></Input>
          </FormItem>
          <FormItem
            label="平台备注信息:"
            style="text-align: left"
            v-show="!!rechage_channel.remark"
          >
            <div
              style="
                width: 260px;
                max-height: 100px;
                overflow: auto;
                border: 1px solid #dcdee2;
                border-radius: 4px;
                padding: 4px;
                line-height: 20px;
                min-height: 32px;
              "
            >
              {{ rechage_channel.remark }}
            </div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="warning" @click.native="closeModal">取消</Button>
        <Button
          type="success"
          @click.native="SaveAppProxyChannel(rechage_channel.modalData, true)"
          >确认修改</Button
        >
      </div>
    </Modal>
    <!-- 验证码 -->
    <Modal v-model="passsWord.show" width="400">
      <p slot="header" style="color: #1c2438; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>密码验证</span>
      </p>
      <div>
        <Form label-position="left">
          <FormItem label="谷歌验证码:">
            <Input
              v-model="passsWord.code"
              style="width: 230px"
              placeholder="谷歌验证码"
            />
            <p style="color: red">请输入6位谷歌验证码，必填</p>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="success" size="large" @click="passsWordFun" long
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetAllProxyPayPlatform,
  GetAppProxyMchConfigList,
  SaveAppProxyMchConfig,
  DelAppProxyMchConfig,
  GetAllAppProxyMch,
  GetAppProxyChannelList,
  SaveAppProxyChannel,
  DelAppProxyChannel,
} from "@/api/admin/newpayment";
import { GetToken } from "../../libs/util";
import { GetAllPlatform, GetAllAppList } from "@/api/admin/risk";
export default {
  name: "PayForChannelConfig",
  data() {
    return {
      SysConstType: {},
      buttonStyle: {
        margin: "2px",
        padding: "5px 20px",
      },
      select: {
        mulPlat: 0,
        mulCode: "",
        mulNewCode: "",
        platform_name: "",
        mulSelect: [],
        all_app_list: [], //所有盘口列表
        pay_list: [], //代付平台列表
        plat_pay_list: [], //盘口代付平台列表
        platform_list: [], //平台列表
        appid_list: [], //盘口列表
        channel_type_list: [
          { name: "银行卡", value: 1 },
          { name: "支付宝", value: 2 },
          { name: "International", value: 3 },
          { name: "虚拟币", value: 5 },
        ], //通道类型列表
      },
      codeTimer: null,
      rechage_channel: {
        show: false,
        remark: "",
        ref: "rechage_channel_ref",
        modalShow: false,
        app_mch_id: 0,
        modalDataName: "",
        modalData: {},
        columns: [
          {
            key: "",
            type: "index",
            minWidth: 50,
            align: "center",
            renderHeader: (h, params) => this.renderHeader(h, "ID", "ID"),
          },
          {
            key: "channel_type",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              return h(
                "span",
                ["银行卡", "支付宝", "微信", "", "虚拟币"][
                  params.row.channel_type - 1
                ]
              );
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, "通道类型", "通道类型"),
          },
          {
            key: "name",
            minWidth: 80,
            align: "center",
            renderHeader: (h, params) =>
              this.renderHeader(h, "代付通道名称", "代付通道名称"),
          },
          {
            key: "status",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              let sys = GetToken().SysConstType;
              return h(
                "span",
                {
                  style: {
                    color: params.row.status == 1 ? "#19be6b" : "#ff9900",
                  },
                },
                params.row.status == 1 ? "启用" : "禁用"
              );
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, "通道状态", "通道状态"),
          },
          {
            key: "",
            align: "center",
            minWidth: 300,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        this.showRechargeChannelModal({
                          ...params.row,
                        });
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: params.row.status == 1 ? "warning" : "success",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        let param = {
                          ...params.row,
                        };
                        param.status = param.status == 1 ? 2 : 1;
                        this.SaveAppProxyChannel(param, false);
                      },
                    },
                  },
                  params.row.status == 1 ? "禁用" : "启用"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "删除",
                          content: "<p>是否确认删除此条代付通道</p>",
                          onOk: () => {
                            let id = params.row.app_mch_id;
                            DelAppProxyChannel({
                              id: params.row.id,
                            }).then((res) => {
                              this.GetAppProxyChannelList(id);
                              this.GetAppProxyMchConfigList();
                            });
                          },
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
            renderHeader: (h, params) => this.renderHeader(h, "操作", "操作"),
          },
        ],
        data: [],
        rules: {
          channel_type: [
            {
              required: true,
              trigger: "change",
              validator: this.simpleVerify("请选择通道类型"),
            },
          ],
          channel_code: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请填写代付通道通道码"),
            },
          ],
          name: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请填写代付通道名称"),
            },
          ],
        },
      },
      Channel_Modal: {
        type: 1,
        show: false,
        mulShow: false,
        mulData: [],
        mulColumn: [
          { type: "selection", align: "center", key: "userSelect" },
          {
            key: "app_name",
            minWidth: 120,
            align: "center",
            renderHeader: (h) =>
              this.renderHeader(h, "盘口信息", "显示对应的盘口名称"),
          },
          {
            key: "pay_type",
            minWidth: 120,
            align: "center",
            render: (h, params) => {
              let sys = GetToken().SysConstType;
              return h("span", sys ? sys.pay_type[params.row.pay_type] : "");
            },
            renderHeader: (h) =>
              this.renderHeader(h, "代付类型", "显示对应的代付类型"),
          },
          {
            key: "name",
            minWidth: 120,
            align: "center",
            renderHeader: (h) =>
              this.renderHeader(h, "代付通道名称", "显示对应的代付通道名称"),
          },
        ],
        ref: "payChannelModal",
        data: { id: 0, name: "", status: 1 },
        rules: {
          app_id: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请配置盘口"),
            },
          ],
          pay_platform_id: [
            {
              required: true,
              trigger: "blur",
              validator: this.simpleVerify("请配置代付平台"),
            },
          ],
        },
      },
      passsWord: { show: false, code: "", type: 2 },
      table: {
        params: {
          page: 1,
          limit: 10,
          plat_id: 0, // 盘口分组 id
          app_id: 0, // 盘口 id
          pay_platform_id: 0, // 代付平台 id
          sort: 1, // 排序
        },
        data: [],
        columns: [
          {
            key: "app_name",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) =>
              this.renderHeader(h, "所属盘口", "显示盘口名称"),
          },
          {
            key: "plat_id",
            align: "center",
            minWidth: 80,
            render: (h, params) =>
              h(
                "span",
                params.row.plat_name || this.getPlatName(params.row.plat_id)
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, "所属分组", "显示盘口的所属分组平台名称"),
          },
          {
            key: "pay_platform_name",
            align: "center",
            minWidth: 80,
            render: (h, params) =>
              h(
                "span",
                `${params.row.pay_platform_name}(${params.row.pay_platform_id})`
              ),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "代付平台",
                "显示配置的代付平台名称+代付平台ID"
              ),
          },
          {
            key: "channel_count",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "代付通道数量",
                "显示该代付平台在该盘口配置的代付通道数量"
              ),
          },
          {
            key: "pay_sum",
            align: "center",
            minWidth: 80,
            render: (h, params) =>
              h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.showChannelModal({
                        type: 4,
                        params: {
                          ...params.row,
                        },
                      });
                    },
                  },
                },
                "查看详情"
              ),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "聚合商户信息",
                "显示该盘口对应聚合商户平台的商户配置信息;点击后弹出输入验证码查询具体信息"
              ),
          },
          {
            key: "",
            align: "center",
            minWidth: 350,
            fixed: "right",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        this.showChannelModal({
                          type: 2,
                          params: {
                            ...params.row,
                          },
                        });
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        this.rechage_channel.remark =
                          params.row.pay_platform_remark;
                        this.rechage_channel.modalDataName =
                          params.row.pay_platform_name;
                        //获取数据
                        this.showRechargeChannel(params.row.id);
                        this.GetAppProxyChannelList(params.row.id);
                      },
                    },
                  },
                  "代付通道管理"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "success",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        let param = {
                          ...params.row,
                        };
                        param.app_id = 0;
                        param.id = 0;
                        this.showChannelModal({
                          type: 3,
                          params: param,
                        });
                      },
                    },
                  },
                  "复制"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                    },
                    style: this.buttonStyle,
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "删除",
                          content: "<p>是否确认删除此盘口数据</p>",
                          onOk: () => {
                            DelAppProxyMchConfig(params.row).then((res) => {
                              this.GetAppProxyMchConfigList();
                            });
                          },
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "管理",
                "管理【编辑】、【代付通道管理】、【复制 】、【删除】"
              ),
          },
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40],
      },
    };
  },
  methods: {
    //列表分页
    pagechange(page) {
      this.table.params.page = page;
      this.GetAppProxyMchConfigList();
    },

    //列表分条
    limitchange(limit) {
      this.table.params.page = 1;
      this.table.params.limit = limit;
      this.GetAppProxyMchConfigList();
    },
    //保存/新增平台通道
    SaveAppProxyChannel(params, isValidate = false) {
      if (!params.app_mch_id)
        params.app_mch_id = this.rechage_channel.app_mch_id;
      if (isValidate) {
        this.$refs[this.rechage_channel.ref].validate(async (valid) => {
          if (valid) {
            SaveAppProxyChannel(params).then((res) => {
              this.GetAppProxyChannelList(params.app_mch_id);
              if (!params.id) {
                this.GetAppProxyMchConfigList();
              }
              this.closeModal();
            });
          }
        });
      } else {
        SaveAppProxyChannel(params).then((res) => {
          this.GetAppProxyChannelList(params.app_mch_id);
          if (!params.id) {
            this.GetAppProxyMchConfigList();
          }
          this.closeModal();
        });
      }
    },
    //获取盘口所有代付平台
    GetAppProxyChannelList(id) {
      GetAppProxyChannelList({
        app_mch_id: id,
      }).then((res) => {
        this.rechage_channel.data = res._param || [];
      });
    },
    //获取平台列表
    async GetAllAppList(value) {
      this.table.params.app_id = 0;
      this.select.platform_name = "";
      if (!value) return (this.select.appid_list = this.select.all_app_list);
      let item = this.select.platform_list.find((el) => el.id == value);
      this.table.params.app_id = 0;
      this.select.platform_name = item ? item.name : "";
      this.select.appid_list = this.select.all_app_list.filter(
        (el) => el.platform == this.table.params.plat_id
      );
    },
    //获取所有平台
    GetAllPlatform() {
      GetAllPlatform({}).then(async (res) => {
        this.select.platform_list = res._param.data || [];
      });
    },
    //获取所有盘口
    getInitAppList() {
      GetAllAppList({
        platform: 0,
      }).then((res) => {
        this.select.all_app_list = (res._param.List || []).filter(
          (el) => el.appid
        );
        this.select.appid_list = this.select.all_app_list;
      });
    },
    //获取盘口代付商户信息列表
    GetAppProxyMchConfigList() {
      let params = { ...this.table.params };
      params.plat_id = params.plat_id || 0;
      params.app_id = params.app_id || 0;
      params.pay_platform_id = params.pay_platform_id || 0;
      GetAppProxyMchConfigList(params).then((res) => {
        this.table.total = res._param.total || 0;
        this.table.data = res._param.list || [];
      });
    },
    //获取代付平台列表
    GetAllProxyPayPlatform() {
      GetAllProxyPayPlatform({}).then((res) => {
        this.select.pay_list = res._param || [];
      });
    },
    //读取盘口所有代付平台
    GetAllAppProxyMch(val) {
      let find = this.select.appid_list.find((el) => el.appid == val);
      if (find && this.table.params.plat_id != find.platform) {
        this.table.params.plat_id = find.platform;
      }
    },

    closeChannelModal() {
      this.Channel_Modal.show = false;
    },
    showChannelModal(param) {
      this.Channel_Modal.show = true;
      this.Channel_Modal.type = param.type;
      this.Channel_Modal.data = param.params;
      this.rechage_channel.remark = param.params.pay_platform_remark;
    },
    closeModal() {
      this.rechage_channel.modalShow = false;
    },
    updateAppMchConfig() {
      this.$refs[this.Channel_Modal.ref].validate(async (valid) => {
        if (valid) {
          let item = this.select.all_app_list.find(
            (el) => el.appid == this.Channel_Modal.data.app_id
          );
          let plat_id = item ? item.platform : 0;
          SaveAppProxyMchConfig({
            ...this.Channel_Modal.data,
            plat_id,
          }).then((res) => {
            this.closeChannelModal();
            this.GetAppProxyMchConfigList();
          });
        }
      });
    },
    showRechargeChannel(id) {
      this.rechage_channel.show = true;
      this.rechage_channel.app_mch_id = id;
    },
    getPlatName(id) {
      if (!id) return "";
      let item = this.select.pay_list.find((el) => el.id == id);
      if (!item) return "";
      return item.name;
    },
    //批量选择id列表
    updateMulSelect(param, cur) {
      this.select.mulSelect = param;
    },

    showRechargeChannelModal(params) {
      this.rechage_channel.modalShow = true;
      this.rechage_channel.modalData = params;
      if (!this.rechage_channel.modalData["id"]) {
        this.rechage_channel.modalData["name"] =
          this.rechage_channel.modalDataName;
      }
    },
    //密码验证
    passsWordFun() {
      if (this.passsWord.code.length != 6) {
        return this.$Message.error("请输入正确的谷歌验证码");
      }
    },
  },
  watch: {
    "Channel_Modal.show": function () {
      if (!this.Channel_Modal.show)
        this.$refs[this.Channel_Modal.ref].resetFields();
    },
    "rechage_channel.modalShow": function (newVal) {
      if (!newVal) this.$refs[this.rechage_channel.ref].resetFields();
    },
  },
  created() {
    this.getInitAppList();
    this.GetAllPlatform();
    this.GetAllProxyPayPlatform();
    this.GetAppProxyMchConfigList();
  },
};
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
